import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { verifCode, resetPasswordBack } from "../../../Redux/sendMailReduce";
import { useParams } from "react-router-dom";

// react-bootstrap components
import { Button, Card, Form, Container, Col } from "react-bootstrap";

function ResetPassword() {
  const location = useParams();
  const [password, setPassword] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [token, setToken] = React.useState(location.code);
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);

  const settings = useSelector((state) => state.settings.entities);

  if (settings.length > 0) {
    document.title = settings[0].name;
  }
  const dispatch = useDispatch();
  const [cardClasses, setCardClasses] = useState("card-hidden");
  const notify = (type, msg) => {
    if (type === 1)
      toast.success(
        <strong>

          {msg}
        </strong>
      );
    else
      toast.error(
        <strong>

          {msg}
        </strong>
      );
  };
  const verifCodee = useCallback(async () => {
    dispatch(verifCode({ token: location.code })).then((e1) => {
      console.log(e1.payload)
      if (e1.payload.email) {
        setCardClasses("");
        setEmail(e1.payload.email);
        setToken(e1.payload.token);
      } else {

        window.location.replace("/login");
      }
    });
  }, [dispatch]);

  useEffect(() => {
    verifCodee();
  }, [verifCodee]);

  const handleBlur = (password, confirmPassword) => {
    if (password !== confirmPassword) {
      setPasswordsMatch(false);
      //notify(2, "Les mots de passe ne correspondent pas");
    } else {
      setPasswordsMatch(true);
    }
  };

  function submitForm(event) {

    const isStrongPassword = (pwd) => {
      const minLength = 12;
      const hasUpperCase = /[A-Z]/.test(pwd);
      const hasLowerCase = /[a-z]/.test(pwd);
      const hasNumber = /[0-9]/.test(pwd);
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(pwd);
      return pwd.length >= minLength && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;
    };

    if (!password || !confirmPassword) {
      notify(2, "Tous les champs sont obligatoires");
    } else if (password !== confirmPassword) {
      notify(2, "Les mots de passe ne correspondent pas");
    } else if (!isStrongPassword(password)) {
      notify(
        2,
        "Le mot de passe doit respecter les règles :\n- Au moins 12 caractères\n- Une majuscule\n- Une minuscule\n- Un chiffre\n- Un caractère spécial"
      );
    } else {
      dispatch(resetPasswordBack({ newPassword: password, token: location.code })).then((e1) => {
        if (e1.payload.success === true) {
          notify(1, e1.payload.message);
          window.location.replace("/login");
        } else {
          notify(2, e1.payload.message);
        }
      });
    }
  }

  return (
    <>
      <ToastContainer />
      <div className="login-page full-gray section-image" data-color="black">

        <div className="block-log full-page login-page">
          <div className="content d-flex align-items-center p-0">
            {/* <Col className="mx-auto" lg="5"> */}
            <Col lg="4" md="8" sm="8" xs="12">
              <Form
                className="form"
                onSubmit={submitForm}
                style={{
                  maxWidth: "420px",
                  margin: "0 auto",
                }}
              >
                <Card
                  className={"card-login " + cardClasses}
                  style={{
                    borderRadius: "15px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                    backgroundColor: "#ffffff",
                    transition: "all 0.3s ease-in-out",
                  }}
                >
                  <div
                    className="img-log"
                    style={{
                      textAlign: "center",
                      marginBottom: "15px",
                    }}
                  >
                    {settings.length > 0 && (
                      <img
                        src={require("../../../assets/img/" + settings[0].logo)}
                        alt="medicacom"

                      />
                    )}
                  </div>

                  <h4
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      marginBottom: "20px",
                      color: "#333",
                    }}
                  >
                    Commande grossiste
                  </h4>

                  <Card.Body>
                    <Form.Group className="margin-bottom">
                      <label style={{ fontWeight: "500" }}>Mot de passe</label>
                      <Form.Control
                        placeholder="Mot de passe"
                        type="password"
                        onChange={(e) => setPassword(e.target.value)}
                        style={{
                          borderRadius: "10px",
                          padding: "10px",
                          border: "1px solid #ccc",
                          marginBottom: "10px",
                        }}
                      />
                      <div
                        style={{
                          marginTop: "5px",
                          fontSize: "0.85rem",
                          color: "#555",
                        }}
                      >
                        <ul
                          style={{
                            paddingLeft: "20px",
                            marginBottom: "0",
                            color: "#555",
                            fontSize: "0.7rem",
                            lineHeight: "1.2",
                            listStyleType: "disc",
                          }}
                        >
                          <li>Au moins 12 caractères</li>
                          <li>Au moins une lettre majuscule</li>
                          <li>Au moins une lettre minuscule</li>
                          <li>Au moins un chiffre</li>
                          <li>Au moins un caractère spécial</li>
                        </ul>

                      </div>
                    </Form.Group>
                    <hr></hr>
                    <Form.Group className="margin-bottom">
                      <label style={{ fontWeight: "500" }}>Confirmer Mot de passe</label>
                      <Form.Control
                        placeholder="Confirmer mot de passe"
                        type="password"
                        onBlur={(e) => {
                          setConfirmPassword(e.target.value);
                          handleBlur(password, e.target.value);
                        }}
                        style={{
                          borderRadius: "10px",
                          padding: "10px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </Form.Group>
                  </Card.Body>

                  <Card.Footer
                    className="ml-auto mr-auto"
                    style={{ textAlign: "center", paddingTop: "15px", borderTop: "none" }}
                  >
                    <Button
                      className="btn-wd"
                      type="button"
                      variant="info"
                      onClick={submitForm}
                      style={{
                        borderRadius: "10px",
                        padding: "10px 30px",
                        fontWeight: "600",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        transition: "all 0.2s",
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.25)")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)")
                      }
                    >
                      Confirmer
                    </Button>
                  </Card.Footer>
                </Card>
              </Form>

            </Col>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
